import { IconProps } from "../../utils/global-types/global-types";

const CampaignsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M14.587 7.21a1.05 1.05 0 0 0-.698-.987.28.28 0 0 0-.241.031.27.27 0 0 0-.11.215V8.48a.27.27 0 0 0 .11.215.28.28 0 0 0 .241.032 1.05 1.05 0 0 0 .698-.992zM13.157 4.206a.78.78 0 0 0-.367-.662c-.436-.278-.772-.047-1.428.273A11.8 11.8 0 0 1 6.068 5.23a.262.262 0 0 0-.262.288v4.51a4.37 4.37 0 0 0 2.415 3.854.527.527 0 1 0 .467-.945 3.29 3.29 0 0 1-1.827-2.846c1.57.122 3.097.564 4.489 1.297.724.341 1.018.525 1.449.268a.79.79 0 0 0 .357-.667zM5.19 5.427a.26.26 0 0 0-.079-.19.26.26 0 0 0-.184-.073h-.525a1.83 1.83 0 0 0-1.837 1.838v1.05a1.84 1.84 0 0 0 1.848 1.832h.525a.263.263 0 0 0 .252-.257z"
      ></path>
    </svg>
  );
};

export default CampaignsIcon;
